import { Suspense, lazy } from "react";

const Footer = lazy(() => import("../components/Footer"));
const Faqs = lazy(() => import("../components/Faqs"));
const Main = lazy(() => import("../components/Main"));
const Header = lazy(() => import("../components/Header"));
const About = lazy(() => import("../components/About"));

function Home() {
  return (
    <div>
      <Suspense
        fallback={
          <div className="bg-white fixed z-50 top-0 left-0 right-0 h-[72px]"></div>
        }
      >
        <Header />
      </Suspense>
      <Suspense
        fallback={
          <div className="relative top-10 bg-[#0070D7] text-white font-roboto w-full min-h-[400px] flex items-center"></div>
        }
      >
        <Main />
      </Suspense>

      <Suspense fallback={<div className="">Loading</div>}>
        <About />
      </Suspense>
      <Suspense fallback={<div className="">Loading</div>}>
        <Faqs />
      </Suspense>
      <Suspense fallback={<div className="">Loading</div>}>
        <Footer />
      </Suspense>
    </div>
  );
}

export default Home;
